// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3jRws","text":"SelectPayment_text__2utll","title":"SelectPayment_title__1Azg_","btn":"SelectPayment_btn__3xs1N"};